var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.32 10 2-7.04H4.56L2.64 10h3.52l-.64 6.96L11.6 10zM16 8 3.04 22.96 4 12H0L3.04.96h10l-2 7.04z"
  })));
};
export default SvgLightning;